import * as React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Icon } from "antd";
import Report3Template from "./Report3Template";

const Report3PDFExportLink = ({
  translate,
  data,
  title,
  subtitle,
  fileName,
  showTitle
}: {
  translate?: any;
  data: any;
  title?: string;
  subtitle?: string;
  fileName: string;
  showTitle?: boolean;
}) => {
  return (
    <PDFDownloadLink
      document={
        <Report3Template
          translate={translate}
          data={data}
          title={title}
          subtitle={subtitle}
          showTitle={showTitle}
        />
      }
      fileName={fileName}
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          translate("reports.document.loading")
        ) : (
          <Icon
            type="file-pdf"
            theme={"outlined"}
            style={{ fontSize: 20, color: "#ED1C24" }}
          />
        )
      }
    </PDFDownloadLink>
  );
};

export default Report3PDFExportLink;
